<template>
  <div></div>
  <!-- <div v-if="nopower==true" class="nopower">
        <img src="../assets/images/icon-no-auth.png" alt />
        <p class="no-auth-text">您暂时无法访问系统</p>
        <p class="no-auth-text-span">如需访问，请提交账号开通流程，如已提交流程，请联系IT客服处理</p> 
    </div> -->
</template>

<script>
import api from "../api/oa";
import Utils from "../utils/utils";
import redirect from "@/webconfig";
export default {
  name: "callBack.vue",
  data() {
    return {
      token: "",
      sid: "",
      code: "",
      PageUrl: "",
      nopower: false,
      state: "",
    };
  },
  methods: {
    // 判断路由重定向
    getRoute() {
      // this.nopower = false
      this.code = Utils.getQueryString("code");
      console.log(this.state, "state");
      if (!this.code) {
        let url = `${redirect.baseUrl}/idp/oauth2/authorize?client_id=${redirect.clientId}&redirect_uri=${redirect.redirectUri}&response_type=code&state=`;
        top.location.href = url;
      } else {
        this.code = this.code.split("#")[0];
        this.getOaRequire();
      }
    },
    getOaRequire() {
      let self = this;
      let code = this.code;
      var reason = "";
      let nopowerUrl = "";
      var systemName = "";
      var bipName = "";
      var telephone = "";
      api
        .bipssoLogin({
          code,
        })
        .then(
          (res) => {
            if (res.data.code === 200) {
              const data = res.data.data;
              Utils.setSession("userInfo", data);
              Utils.setLocalStorage("userInfo", data);
              top.location.href = `${redirect.redirectUri}#/home?code=${this.code}&link=${this.state}`;
            }
          },
          (err) => {
            if (err.code == 401) {
              reason = encodeURIComponent("统一认证未授权");
              nopowerUrl = `${redirect.baseUrl}/idp/themes/error/defpage-403.html?systemName=${systemName}&bipName=${bipName}&telephone=${telephone}&reason=${reason}`;
              top.location.href = nopowerUrl;
            }
            if (err.code == 111013) {
              reason = encodeURIComponent("商业资产经营管理平台未授权");
              systemName = encodeURIComponent("商业资产经营管理平台");
              bipName = encodeURIComponent("张梅花");
              telephone = 13632389165;
              nopowerUrl = `${redirect.baseUrl}/idp/themes/error/defpage-403.html?systemName=${systemName}&bipName=${bipName}&telephone=${telephone}&reason=${reason}`;
              top.location.href = nopowerUrl;
            }
          }
        )
        .catch((err) => {
          console.log(err);
          //this.nopower = true
        });
    },
  },
  // beforeRouteEnter(to,from,next){
  //     console.log('beforeRouter')
  //     let oaCode = Utils.getQueryString('code') || '';
  //     if(Utils.getLocalStorage('userInfo')){
  //         next()
  //     } else{
  //         if(!oaCode) {
  //             next('/login')
  //         } else {
  //             next(vm=>{
  //                 let url = `${redirect.baseUrl}/idp/profile/SAML2/Redirect/GLO?redirctToUrl=${redirect.redirectUri}&redirectToLogin=true&entityId=sguat`;
  //                 top.location.href=url
  //                 //top.location.href = `${redirect.baseUrl}/login`
  //             })
  //         }
  //     }
  // },
  created() {
    if (window.location.search.indexOf("k2Url") > 0) {
      var state = window.location.search.split("state=")[1];
      var temp = state.split("_");
      console.log(temp, "temp");
      if (temp[5]) {
        this.state = `/finance/#/costOrderManage?contractId=${temp[1]}&contractType=${temp[2]}&mallCode=${temp[3]}&contractCode=${temp[4]}&mallName=${temp[5]}&actionType=view&fetchOrigin=true&fromPath=k2Path`;
      } else {
        this.state = `/contract/#/contractNew?contractId=${temp[1]}&contractType=${temp[2]}&actionType=view&fetchOrigin=true&fromPath=k2Path`;
      }
    }
    this.getRoute();
  },
};
</script>

<style scoped>
</style>